import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
import { withStyles, withTheme } from "@material-ui/core";
import Typography from "../../../../components/Helpers/Typography";
import useMediaQuery from "../../../../hooks/useMediaQuery";

const styles = theme => ({
  root: {
    margin: "5px 0 0 0",
    alignItems: "center",
    display: "flex",
    textTransform: "capitalizeFirstWord",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      top: 20,
      right: 20,
    },
  },
  div: {
    fontSize: 14,
    display: "flex",
    paddingRight: 20,
  },
  span: {
    paddingRight: 10,
  },
});

const VehicleHistorySubheader = props => {
  const { classes, tripInfo, t, theme } = props;

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div
      className={classes.root}
      style={{
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : null,
      }}
    >
      <div className={classes.div}>
        <span className={classes.span}>
          <Typography color="secondary">{t("Vehicles.Detail.Trips")}</Typography>
        </span>
        <Typography>{tripInfo.totalTrips}</Typography>
      </div>

      <div className={classes.div}>
        <span className={classes.span}>
          <Typography color="secondary">{t("Vehicles.Detail.History.Trips/day")}</Typography>
        </span>
        <Typography>{tripInfo.tripsPerDay}</Typography>
      </div>
    </div>
  );
};

VehicleHistorySubheader.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  tripInfo: PropTypes.shape({
    totalTrips: PropTypes.number,
    averageTripTime: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    tripsPerDay: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation("common")(withTheme(VehicleHistorySubheader)));
